var exports = {
  "x6": "GuildListDMItem.module__button___LVhnd3",
  "V8": "GuildListDMItem.module__relative___LVhnd3",
  "PH": "GuildListDMItem.module__fullSize___LVhnd3",
  "SU": "GuildListDMItem.module__muted___LVhnd3",
};

module.exports = exports;
